module.exports = __webpack_public_path__ + "static/media/landscape.713913bc.jpg";